/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Canceled_ReasonInputs */

const en_settings_billing_canceled_reason = /** @type {(inputs: Settings_Billing_Canceled_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason`)
};

const zh_settings_billing_canceled_reason = /** @type {(inputs: Settings_Billing_Canceled_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消原因`)
};

/**
* | output |
* | --- |
* | "Reason" |
*
* @param {Settings_Billing_Canceled_ReasonInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_canceled_reason = /** @type {((inputs?: Settings_Billing_Canceled_ReasonInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Canceled_ReasonInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_canceled_reason(inputs)
	return zh_settings_billing_canceled_reason(inputs)
});
export { settings_billing_canceled_reason as "settings.billing.canceled_reason" }